module.exports = __webpack_public_path__ + "static/media/hanako.9805aaef.png";